'use client';
import '~theme/global.css';

import { useEffect } from 'react';

import { H2, P } from '~components/Typography';
import {
	Level,
	Logger,
	LoggerMessages,
	LoggerServices,
} from '~shared/services/logger';
// TODO: Design/markup, insta redirect?
export default function GlobalError({
	error,
	reset,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	useEffect(
		() =>
			Logger.shared.log(
				Level.error,
				LoggerServices.Global,
				LoggerMessages.Unknown,
				{ error }
			),
		[error]
	);

	return (
		<html>
			<body>
				<div
					id="__next"
					style={{ justifyContent: 'center', alignItems: 'center', gap: 20 }}
				>
					<H2>Something went wrong!</H2>
					<button onClick={() => reset()}>
						<P size="large">Try again</P>
					</button>
				</div>
			</body>
		</html>
	);
}
